/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SalesChannel = {
    _11184809: '11184809',
    ONLINE: 'ONLINE',
    RETAIL: 'RETAIL',
    unknown_default_open_api: '11184809'
} as const;
export type SalesChannel = typeof SalesChannel[keyof typeof SalesChannel];


export function instanceOfSalesChannel(value: any): boolean {
    for (const key in SalesChannel) {
        if (Object.prototype.hasOwnProperty.call(SalesChannel, key)) {
            if (SalesChannel[key as keyof typeof SalesChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SalesChannelFromJSON(json: any): SalesChannel {
    return SalesChannelFromJSONTyped(json, false);
}

export function SalesChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesChannel {
    return json as SalesChannel;
}

export function SalesChannelToJSON(value?: SalesChannel | null): any {
    return value as any;
}

